/* tslint:disable: directive-selector */
import {
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { IRentabilidad } from '../../Entities/traslado.entities';

@Directive({ selector: '[app-tooltip]' })
export class TooltipDirective implements OnInit {
  @Input('app-tooltip') text = '';
  @Input() position = 'bottom';
  @Input() rentabilidadAnual: IRentabilidad;
  @Input() rentabilidadSemestral: IRentabilidad;
  @Input() rentabilidadMensual: IRentabilidad;

  private overlayRef: OverlayRef;

  constructor(
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private overlay: Overlay
  ) {}

  ngOnInit() {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'center',
          overlayY: 'top',
        },
      ]);

    this.overlayRef = this.overlay.create({ positionStrategy });
  }

  @HostListener('mouseenter')
  show() {
    const tooltipPortal = new ComponentPortal(TooltipComponent);
    const tooltipRef: ComponentRef<TooltipComponent> = this.overlayRef.attach(
      tooltipPortal
    );
    tooltipRef.instance.text = this.text;
    tooltipRef.instance.position = this.position;
    tooltipRef.instance.rentabilidadAnual = this.rentabilidadAnual;
    tooltipRef.instance.rentabilidadMensual = this.rentabilidadMensual;
    tooltipRef.instance.rentabilidadSemestral = this.rentabilidadSemestral;
  }

  @HostListener('mouseleave')
  hide() {
    this.overlayRef.detach();
  }
}
